var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-page-content-wrapper", attrs: { id: "roles" } },
    [
      _vm.isEdit
        ? [
            _c("role-edit", {
              ref: "roleEditComponent",
              attrs: { roleId: _vm.roleId },
              on: { saved: _vm.onRoleSaved, cancelled: _vm.goBackToRoles },
            }),
          ]
        : [
            _c("supsis-table", {
              key: _vm.paginationCursor.page,
              attrs: {
                columns: _vm.cols,
                rows: _vm.roles,
                "bottom-pagination": true,
                "pagination-cursor": _vm.paginationCursor,
              },
              on: {
                "cursor-changed": function (cursor) {
                  return _vm.handlePageChange(cursor)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-between align-items-center",
                        },
                        [
                          _c("a-input-search", {
                            staticClass: "search-input",
                            attrs: { placeholder: _vm.$t("message.search") },
                            on: { search: _vm.onSearch },
                            model: {
                              value: _vm.searchText,
                              callback: function ($$v) {
                                _vm.searchText = $$v
                              },
                              expression: "searchText",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "SupsisButton",
                            {
                              attrs: { ghost: "" },
                              on: { click: _vm.createNewRole },
                            },
                            [
                              _c("md-icon", [_vm._v("add")]),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("message.createRole")) +
                                  "\n                    "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }